import { Component, Input, TemplateRef, ViewChild, ContentChild } from '@angular/core';

@Component({
  selector: 'nc-splitter-panel',
  template: `
  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
  `,
  styles: [`
    :host {
      display: flex;
      overflow: auto;
      width: 100%;
      height: 100%;
    }
  `]
})
export class SplitterPanelComponent {
  @Input() ncPanelSize?: number;
  @Input() ncMinSize?: number;
  @ViewChild('content') contentTemplate!: TemplateRef<any>;
}